// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__mE_xX","colMaxWidth":"Table_colMaxWidth__2zX1m"};